'use client';

import NewsTile from '@/components/NewsTile';
import Section from '@/components/Section';
import ShowTile from '@/components/ShowTile';
import ButtonLink from '@/components/atoms/ButtonLink';
import type { Event_Entry, NewsArticle_Entry, PagePart_Highlights_Entry } from '@/types/graphql';
import { cn } from '@/utils/cn';
import { useTranslations } from 'next-intl';

interface HighlightedShowsWithNewsProps {
    events: Event_Entry[];
    newsEntry?: NewsArticle_Entry;
    pagePart?: PagePart_Highlights_Entry;
    locale: string;
}

export default function HighlightedShowsWithNews({
    events,
    newsEntry,
    pagePart: _pagePart,
    locale,
}: HighlightedShowsWithNewsProps) {
    const t = useTranslations('HighlightedShowsWithNews');

    return (
        <Section title="Highlights" variant="collection">
            <div className="grid w-full grid-cols-1 gap-y-6 sm:grid-cols-3 sm:gap-x-6 lg:grid-cols-3 xl:grid-cols-4">
                <div className={cn(newsEntry ? 'col-span-3' : 'col-span-4')}>
                    <div className="grid w-full grid-cols-1 gap-6 sm:grid-cols-2 xl:grid-cols-3">
                        {events?.map((event) => (
                            <ShowTile
                                key={event.id}
                                event={event}
                                priority={true}
                                className={'event-tile'}
                                locale={locale}
                            />
                        ))}

                        <div className="hidden sm:block xl:hidden">
                            {newsEntry && (
                                <NewsTile tag="Update" title={newsEntry.title || ''}>
                                    {newsEntry.newsText || ''}
                                </NewsTile>
                            )}
                        </div>
                    </div>
                    <ButtonLink href="#show-ladder" variant="active" className="mt-8">
                        {t('show-all-highlights')}
                    </ButtonLink>
                </div>

                {newsEntry && (
                    <div className="block sm:hidden xl:block">
                        <NewsTile tag="Update" title={newsEntry.title || ''}>
                            {newsEntry.newsText || ''}
                        </NewsTile>
                    </div>
                )}
            </div>
        </Section>
    );
}
